export default __webpack_public_path__ + "static/media/logout.d03bb0bc.svg";